import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  className?: string;
}

const CTASection = ({ className = '' }: CTASectionProps) => {
  return (
    <section className={`py-16 lg:py-24 bg-gradient-to-br from-primary to-secondary ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline text-white mb-6">
            Ready to Transform Your AI Journey?
          </h2>
          <p className="text-lg md:text-xl text-white/90 font-body leading-relaxed mb-8">
            Let\'s discuss how our human-centered approach can help your organization succeed with AI transformation. Book a discovery call to explore how we can support your goals.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/contact"
              className="inline-flex items-center justify-center space-x-2 px-8 py-4 rounded-md font-bold font-cta text-base text-primary bg-white hover:bg-white/90 transition-all duration-300 shadow-strong hover:shadow-modal hover:-translate-y-0.5"
            >
              <span>Book Discovery Call</span>
              <Icon name="ArrowRightIcon" size={20} variant="outline" />
            </Link>
            <Link
              href="/partner-network"
              className="inline-flex items-center justify-center space-x-2 px-8 py-4 rounded-md font-bold font-cta text-base text-white bg-white/10 hover:bg-white/20 border-2 border-white transition-all duration-300"
            >
              <span>Join Partner Network</span>
              <Icon name="UserGroupIcon" size={20} variant="outline" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;